import { Injectable } from '@angular/core';
import * as fs from 'file-saver';
import * as XLSX from 'xlsx-js-style';

import { FileService } from './file.service';

const EXCEL_EXTENSION = '.xlsx';

@Injectable({providedIn: 'root'})
export class ExportXlsxService {

    constructor(private fileService: FileService) {
    }

    public export(title: string, subtitle: string[] = [], table: any[]): void {
        
        const worksheetData: any[][] = [];
        
        worksheetData.push([title]);
        
        subtitle.forEach(s => worksheetData.push([s]));
        
        worksheetData.push(['Gerado em: ' + new Date().toLocaleString()]);
        
        worksheetData.push([]);
        
        table.forEach(row => worksheetData.push(row));

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        
        if (worksheet['A1']) {
            worksheet['A1'].s = {
                font: { 
                    name: 'Calibri',
                    sz: 16, 
                    bold: true 
                }
            };
        }

        const tableStartRow = subtitle.length + 3;
        const numRows = table.length;
        const numCols = table[0] ? table[0].length : 0;

        for (let row = tableStartRow; row < tableStartRow + numRows; row++) {
            for (let col = 0; col < numCols; col++) {
                const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
                if (worksheet[cellAddress]) {
                    worksheet[cellAddress].s = {
                        border: {
                            top: { style: 'thin', color: { rgb: '000000' } },
                            left: { style: 'thin', color: { rgb: '000000' } },
                            bottom: { style: 'thin', color: { rgb: '000000' } },
                            right: { style: 'thin', color: { rgb: '000000' } }
                        }
                    };
                }
            }
        }
        
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, title);

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
        fs.saveAs(blob, title + '_' + new Date().getTime() + EXCEL_EXTENSION);
    }
}